import { Box, Checkbox, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../Redux/hooks";
import { updateResponse } from "../../../../Redux/reducers/providerConsentSlice";
import { useTranslation } from "react-i18next";

type Props = {
  currentBlock: any;
};

const CheckboxField = ({ currentBlock }: Props) => {
  const { t } = useTranslation("econsent");
  const dispatch = useAppDispatch();
  const label = currentBlock?.label;
  const checked = currentBlock?.response?.checked;
  const displayType = currentBlock?.config?.displayType || "checkbox";

  const handleChange = (_: any, checked: boolean) => {
    if (currentBlock.editable)
      dispatch(
        updateResponse({
          blockId: currentBlock.id,
          key: "checked",
          value: checked,
        })
      );
  };

  const handleYesNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!currentBlock.editable) return;
    dispatch(
      updateResponse({
        blockId: currentBlock.id,
        key: "checked",
        value: event.target.value === "yes",
      })
    );
  };

  if (displayType === "yes_no") {
    return (
      <Box>
        {label && (
          <Typography
            variant="h3"
            sx={{
              color: "text.primary",
            }}
          >
            {label}
          </Typography>
        )}
        <RadioGroup value={typeof checked === "boolean" ? (checked ? "yes" : "no") : ""} onChange={handleYesNoChange}>
          <FormControlLabel
            value="yes"
            control={<Radio inputProps={{ readOnly: true }} />}
            label={t("BUILDER_UI.PREVIEW_YES")}
          />
          <FormControlLabel
            value="no"
            control={<Radio inputProps={{ readOnly: true }} />}
            label={t("BUILDER_UI.PREVIEW_NO")}
          />
        </RadioGroup>
      </Box>
    );
  }

  return (
    <FormControlLabel
      control={<Checkbox checked={checked ?? false} onChange={handleChange} />}
      label={label}
      sx={{ display: "block" }}
    />
  );
};
export default CheckboxField;
